
import { 
	FETCH_VERANSTALTUNG_REQUEST_SUCCESS, 
	ADD_VERANSTALTUNG_PANEL_SET_VNR, 
	ADD_VERANSTALTUNG_PANEL_SET_VNRPWD, 
	ADD_VERANSTALTUNG_PANEL_SET_VNR_CREDENTIALS,
	DELETE_VERANSTALTUNG,
	ADD_VERANSTALTUNG_PANEL_SET_COLLAPSED} from './actions'
	
import { getVeranstaltungsCredentials } from './fobiAppBarcodeContentRecogniser';

const initialStateAddVeranstaltungsPanel = {
		vnr: "",
		vnrpwd: "",
		showAddVeranstaltungArea: false
	};


const stummModusDurationinMS = 3200

const addVeranstaltungController = { stummModus : false, timeoutHandle: null }

const disengageStummModus = () => {
	addVeranstaltungController.stummModus = false
	addVeranstaltungController.timeoutHandle = null
}
const engageStummModus = () => {
	addVeranstaltungController.stummModus = true
	if(addVeranstaltungController.timeoutHandle) clearTimeout(addVeranstaltungController.timeoutHandle)
	addVeranstaltungController.timeoutHandle = setTimeout( () => disengageStummModus(), stummModusDurationinMS)
}

export const addVeranstaltungPanelReducer = (state = initialStateAddVeranstaltungsPanel, action) => {
 switch(action.type) {
	 	case ADD_VERANSTALTUNG_PANEL_SET_VNRPWD:{
			if(addVeranstaltungController.stummModus) {
				engageStummModus()
				return state;
			}
			const data = getVeranstaltungsCredentials(action.payload);
			if(data === null) return {...state, vnrpwd: action.payload};
			// Ohne Kennwort sind es keine Zugangsdaten - siehe ADD_VERANSTALTUNG_PANEL_SET_VNR.
			if(!data.pwd) return {...state, vnr: data.vnr};
			engageStummModus()
			return {...state, vnrpwd: data.pwd, vnr: data.vnr};
		 }
		case ADD_VERANSTALTUNG_PANEL_SET_COLLAPSED :{
			return {...state, showAddVeranstaltungArea: action.payload}
		}
		case ADD_VERANSTALTUNG_PANEL_SET_VNR:{
			if(addVeranstaltungController.stummModus){ 
				engageStummModus()
				return state;
			}
			const data = getVeranstaltungsCredentials(action.payload);
			if(data === null) return {...state, vnr: action.payload };
			// **Eine blosse VNR sind keine Zugangsdaten.** getVeranstaltungsCredentials hat einen
			// Auffangzweig, der aus beliebigem Text eine VNR heraussucht und {vnr, pwd: ""}
			// liefert. Der galt hier als "gescannt": das Kennwortfeld wurde mit "" ueberschrieben
			// und der Stummmodus lief an, der die naechsten 3,2 s Eingaben verschluckt. Wer von
			// Hand VNR und Kennwort eintrug, verlor deshalb je nach Reihenfolge das Kennwort oder
			// dessen erste Zeichen.
			//
			// Erkannt wird die VNR weiterhin (ein eingefuegtes "VNR: 276..." landet sauber im
			// Feld), aber ohne Kennwort wird nichts verteilt: das Kennwortfeld bleibt unberuehrt
			// und der Stummmodus bleibt aus. Der Kamera-Scanner ist davon nicht betroffen, er
			// dispatcht ADD_VERANSTALTUNG_PANEL_SET_VNR_CREDENTIALS.
			if(!data.pwd) return {...state, vnr: data.vnr};
			engageStummModus()
			return {...state, vnrpwd: data.pwd, vnr: data.vnr};
		}
		case ADD_VERANSTALTUNG_PANEL_SET_VNR_CREDENTIALS:{
			const {vnr, pwd} = action.payload;
			return {...state, vnrpwd: pwd, vnr};
		}

		case FETCH_VERANSTALTUNG_REQUEST_SUCCESS:
			return {...state, vnr: "", vnrpwd: "", showAddVeranstaltungArea: false}							
	 default:
		  return state;
 }
}

export const veranstaltungenReducer = (state = {}, action) => {
	switch (action.type) {
		case DELETE_VERANSTALTUNG:
			const veranstaltungen = {...state}
			delete veranstaltungen[action.vnr]
			return veranstaltungen
		case FETCH_VERANSTALTUNG_REQUEST_SUCCESS:
			return {...state,  [action.veranstaltung.vnr] : action.veranstaltung }
		default:
			return state;
	}
}

